import { KeyboardEvent, useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";

import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { useEQM2060_R01Store } from "./Store_EQM2060_R01";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onNickel1PdfClick: () => void;
  onNickel2PdfClick: () => void;
  onOilWaterPdfClick: () => void;
}

export const SearchSection_EQM2060_R01 = ({
  onEnterKeyDown,
  onNickel1PdfClick,
  onNickel2PdfClick,
  onOilWaterPdfClick,
}: Props) => {

	const { EQM2060_R01Filter, setEQM2060_R01Filter } = useEQM2060_R01Store();
	const { compCdList, yesNoList } = useCommonCodeStore();
	
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
		<SearchDropDownForm
			label="사업장"
			value={EQM2060_R01Filter.compCd}
			optionList={compCdList}
			onChangeItem={(selectedItem) => setEQM2060_R01Filter({ compCd: selectedItem?.compCd || '' })}
		/>
		
		<SearchMonthSingleForm
				label="생산년월"
				visible={pickerVisible}		setVisible={setPickerVisible}
				value={new Date(EQM2060_R01Filter.inspectionMonth)}
				editable={true}
				onChange={(date) => setEQM2060_R01Filter({ inspectionMonth: formatDateYear4(date)+'-'+formatDateMonth(date) })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<button
				onClick={onNickel1PdfClick}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				니켈 1-1호기
			</button>
			<button
				onClick={onNickel2PdfClick}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				니켈 1-2호기
			</button>
			<button
				onClick={onOilWaterPdfClick}
				className="flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold px-4 rounded shadow h-[30px]"
			>
				유수분리기
			</button>
	</SearchSectionForm>
  );
};